import { Compass, BookOpen, Swords, Shield, Gem, ScrollText, Sparkles, Map } from 'lucide-react';
import { getCategoryDescendantIds } from '../../contexts/WikiContext';

export const categoryId = (page) => String(page.category?.id ?? page.categoryId ?? page.category ?? '');
export const categoryHref = (id) => `/wiki?category=${encodeURIComponent(id)}`;
export const pageHref = (page) => `/wiki/${encodeURIComponent(page.slug)}`;
export const pageHtml = (page) => page?.content ?? page?.contentHtml ?? '';
export function plainText(html) {
  const doc = new DOMParser().parseFromString(html || '', 'text/html');
  doc.querySelectorAll('script,style').forEach((el) => el.remove());
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}
export function articleInfo(page) {
  const doc = new DOMParser().parseFromString(pageHtml(page), 'text/html');
  const headings = Array.from(doc.querySelectorAll('h1,h2,h3,h4,h5,h6'))
    .map((el, index) => ({ id: `heading-${index}`, text: el.textContent.trim(), level: Number(el.tagName[1]) }))
    .filter((h) => h.text);
  const intro = Array.from(doc.querySelectorAll('p,blockquote')).map((p) => p.textContent.replace(/\s+/g, ' ').trim())
    .find((text) => text.length > 45 && !text.startsWith('/')) || '';
  return { headings, intro: intro.length > 230 ? intro.slice(0, 227) + '…' : intro,
    minutes: Math.max(1, Math.ceil(plainText(pageHtml(page)).split(/\s+/).length / 180)) };
}
export function pagesInCategory(pages, category) {
  const ids = new Set(getCategoryDescendantIds(category).map(String));
  return pages.filter((p) => ids.has(categoryId(p)));
}
export function searchPages(pages, query) {
  const words = query.toLocaleLowerCase('ru-RU').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return pages;
  return pages.map((page) => {
    const title = (page.title || '').toLocaleLowerCase('ru-RU');
    const text = `${title} ${plainText(pageHtml(page)).toLocaleLowerCase('ru-RU')}`;
    return { page, score: words.every((word) => text.includes(word)) ? 1 + words.filter((word) => title.includes(word)).length * 10 : 0 };
  }).filter((item) => item.score).sort((a, b) => b.score - a.score).map((item) => item.page);
}
export function themeFor(value = '') {
  const text = value.toLowerCase();
  if (/босс|подзем|монстр|boss|monster/.test(text)) return { icon: Swords, color: '#ef9b76', image: '/bg.png', label: 'Приключения', description: 'Испытания, противники и тайны подземелий.' };
  if (/брон|оруж|предмет|item|снаряж/.test(text)) return { icon: Shield, color: '#e7c585', image: '/screens/Hytale2026-03-15_23-34-55.png', label: 'Снаряжение', description: 'Предметы и снаряжение для твоего путешествия.' };
  if (/гайд|guide|faq|команд|перв/.test(text)) return { icon: BookOpen, color: '#68dbb7', image: '/background.png', label: 'Гайды', description: 'Полезные команды и ответы на вопросы игроков.' };
  if (/обнов|update/.test(text)) return { icon: Sparkles, color: '#a6b4ff', image: '/bg.png', label: 'Обновления', description: 'История изменений и новые возможности сервера.' };
  if (/ресурс|resource/.test(text)) return { icon: Gem, color: '#86cee4', image: '/background.png', label: 'Ресурсы', description: 'Материалы, добыча и всё для создания предметов.' };
  if (/лор|lore|организац/.test(text)) return { icon: ScrollText, color: '#c0a1ee', image: '/bg.png', label: 'Истории мира', description: 'Истории и тайны, из которых складывается InterWorld.' };
  if (/локац|location/.test(text)) return { icon: Map, color: '#8fc9b2', image: '/background.png', label: 'Локации', description: 'Места, которые стоит исследовать.' };
  return { icon: Compass, color: '#68dbb7', image: '/background.png', label: 'Мир InterWorld', description: 'Знакомство с миром и его возможностями.' };
}
export const newestFirst = (a, b) => (Date.parse(b.updatedAt || b.createdAt) || 0) - (Date.parse(a.updatedAt || a.createdAt) || 0);
